import { BottomNavigation } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import Header from "./Header";
import Home from "./Home";
import Login from "./Login";
import Profile from "./Profile";
import UserVerify from "./Userverify";
const AppRouter = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status
  const [username, setUsername] = useState(null); // Track logged-in username

  // Check localStorage for login status on initial render
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setIsLoggedIn(true);
      setUsername(storedUsername);
    }
  }, []);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("username"); // Clear username from localStorage
    setIsLoggedIn(false);
    setUsername(null);
    window.location.href = "/login";
  };

  return (
    <Router>
      {/* Conditionally render Header if logged in */}
      {isLoggedIn && <Header username={username} onLogout={handleLogout} />}
      <Routes>
        {/* Redirect to Login if not logged in */}
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              username === "admin" ? (
                <Navigate to="/admin" replace />
              ) : (
                <Navigate to="/userVerify" replace />
              )
            ) : (
              <Login setLoggedIn={setIsLoggedIn} setUsername={setUsername} />
            )
          }
        />
        <Route
          path="/account"
          element={isLoggedIn ? <Profile /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/userVerify"
          element={
            isLoggedIn && username !== "admin" ? (
              <UserVerify />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin"
          element={
            isLoggedIn && username === "admin" ? (
              <AdminDashboard />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={
            isLoggedIn ? (
              username === "admin" ? (
                <Navigate to="/admin" replace />
              ) : (
                <Home />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
      {/* Conditionally render Footer if logged in */}
      {isLoggedIn && (
        <BottomNavigation
          showLabels
          sx={{
            backgroundColor: "#2C3E50",
            color: "#fff",
            textAlign: "center",
            padding: 2,
            position: "fixed",
            bottom: 0,
            width: "100%",
          }}
        ></BottomNavigation>
      )}
    </Router>
  );
};

export default AppRouter;
